import { API } from "aws-amplify";

const insert = async params => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };
  let res = await API.post("InasakuAPI", "/api/payment", myInit);
  return res;
};
const del = async params => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: params
    },
    headers: {} // OPTIONAL
  };
  let res = await API.del("InasakuAPI", "/api/payment", myInit);
  return res;
};

export default {
  insert: insert,
  del: del
};
